import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";

import Projects from "./components/Projects";
import Resume from "./components/Resume";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function App() {
  return (
    <div className="bg-gray-50 text-gray-900">
      <Header />
      <Hero />
      <About />
      
      <Projects />
      <Resume />
      <Contact />
      <Footer />
    </div>
  );
}
